import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import {Typography} from '@mui/material';
import { Theme } from '@mui/styles';
import {Paper} from '@mui/material';
import {Toolbar} from '@mui/material';
import {Button} from '@mui/material';
import {Grid} from '@mui/material';
import ErrorView from '~common/components/error-view';
import SuccessView from '~common/components/success-view';
import LoadingView from '~common/components/loading-view';
import { APIError } from '~common/lib/types';
import EmptySet from "~common/components/empty-set"
import * as request from 'superagent';
import {FormControl, InputLabel, Tooltip, FormHelperText} from '@mui/material';
import AutoSuggest, {AutoSuggestQuery} from '~common/components/autosuggest';
import ProxyFeatureAssignment from './proxy-feature-assignment-view'
import URLManager from '~common/lib/url-manager';

const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	},
	paper: {
		padding: 30
	},
	heading: {
		marginTop: 30,
		borderBottom: '1px solid #ccc'
    },
    headerPaper: {
		padding: 30
    },
    root: {
		width: '100%'
	},
	formField: {
		width: '100%'
	},
	admintoolbar: {
		justifyContent: 'flex-end'
	},
	textField: {
		width: "100%"
    },
    headerTitle: {
        marginBottom: 10
	},
	booleanField: {
		width: "100%"
	},
	deleteIcon: {
		marginRight: 10,
		marginBottom: 20
    },
    proxyUserFullName: {
        width: "100%",
    },
    switchClass: {
        width: 100,
    },
    approvalRoutes: {
        width: 100,
    },
    searchField: {
        width: "100%",
    },
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
	portalUserID: any;
}

type State = {
	isNew: boolean;
	error?: APIError;
    success?: string;
    searching?: boolean;
    portalUser: any;
    proxies: Array<any>;
    features: Array<any>;
	status: 'loading' | 'ready' | 'saving';
};

class PcardFeatureProxyEditView extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	_validationErrors: Array<any>;
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			isNew: false,
            status: 'loading',
            portalUser: {},
            proxies: [],
            features: []
		};
        
	}

	componentDidMount() {
        const {portalUserID} = this.props
        if (portalUserID == "new") {
            this.setState({status: "ready", isNew: true})
        } else {
            Promise.all([
                request.get(`/api/portal-user-proxy/${portalUserID}`),
            ]).then((values)=>{
                var response = values[0]

                var proxyAssignments =response.body.proxies
              
                // these features are scoped to the portal user which is having proxy administered to. 
                var proxyAbleFeatures = response.body.features

                this.setState({
                    status: "ready",
                    portalUser: response.body.portalUser || {},
                    proxies: proxyAssignments,
                    features: proxyAbleFeatures
                })

            }).catch((err)=>{
                const apiErr = new APIError()
                apiErr.type = "http"
                apiErr.message = "Error fetching data"
                apiErr.details = (err.response || {text: err.toString()}).text
                this.setState({
                    error: apiErr
                })
            })

        }
	}

	handleSaveClick = () => {
        this._validationErrors = []
        var {proxies, portalUser} = this.state
        
        var formValid = true

        if (!portalUser.id) {
            formValid = false
            this._validationErrors.push(`<div class="error-standard-rule" style="margin-left:10px">Missing Portal User</div>`)
        } else {
            if (proxies.length == 0) {
                formValid = false
                this._validationErrors.push(`<div class="error-standard-rule" style="margin-left:10px">No Proxies have been added</div>`)
            }
        }

      

        proxies.forEach((p: any)=>{
            // console.log("validating proxy", p)
            if (!p.extendedAttributes["_delete"]) {
                if (!p.proxyToUserID) {
                    // p.proxyToUserID.error = "This field is required"
                    p._proxyToUserIDMissing = true
                    this._validationErrors.push(`<div class="error-standard-rule" style="margin-left:10px">Missing Proxy User</div>`)
                    formValid = false
                } else {
                    p._proxyToUserIDMissing = false
                }
            }
        })

        if (!formValid) {
			let err = new APIError()
			err.message = "Validation Errors Exist!"
			err.template = `<div id="validation-errors">
                                Validation Errors: <br>
                                ${this._validationErrors.join("")}
                            </div>`
			this.setState({
				error: err
			})
		} else {
            // save the proxies and features
            var payload = proxies.map((p: any)=>{
                // var modelData = p.modelData
                if (p.extendedAttributes["features"]) {
                    var features = Array<any>();
                    p.extendedAttributes["features"].forEach((f: any)=>{
                        features.push(f)
                    })

                    delete p.extendedAttributes["features"]
                    
                    p.proxyFeatures = features
                }
                return p
            })

            request.put(`/api/portal-user-proxy/${this.state.portalUser.id}`).send(payload).then((response: request.Response)=>{
                // console.log("response", response)
                if (!response.ok) {
                    const apiErr = new APIError()
                    apiErr.type = "api"
                    apiErr.message = "Error Saving Proxies"
                    apiErr.details = response.body.toString()
                    this.setState({
						error: apiErr
					})
                } else {
                    window.location.href = `/feature-proxy/admin?q=${URLManager.getQueryStringValueByKey("q", window.location.href)}`
                }
            }).catch((err)=>{
                console.error(err)
                const apiErr = new APIError()
                apiErr.type = "http"
                apiErr.message = "Error fetching data"
                apiErr.details = (err.response || {text: err.toString()}).text
                this.setState({
                    error: apiErr
                })
            })


        }

	};

	onErrorClose = () => {
		this.setState({error: undefined})
	}

	onSuccessClose = () => {
		this.setState({success: undefined})
	}

	handleEnumSelectChange = (attr: any): any => (val: any): void => {
		if (attr.handleChange) {
			attr.error = undefined
			attr.handleChange({target:{value:val}});
			this.setState({})
		}	
    };
    

	cancel = () => {
		window.location.href = `/feature-proxy/admin?q=${URLManager.getQueryStringValueByKey("q", window.location.href)}`
    }
    
   
    newProxy = () => {
        var {proxies, portalUser} = this.state
        proxies.push({portalUserID: portalUser.id, extendedAttributes: {}})
        this.setState({
            proxies: proxies
        })
    }

    fetchSuggestions = (resource: string, optionKey: string) => (query: AutoSuggestQuery):  Promise<any> => {
        // console.log("fetchSuggestions", query)
        return new Promise((resolve, reject) => {
            request.get(`/api${resource}${query.value}`).then((response: request.Response)=>{
                if (!response.ok) {
                    const apiErr = new APIError()
                    apiErr.type = "api"
                    apiErr.message = "Error fetching data"
                    apiErr.details = response.body.toString()
                    reject(apiErr)
                }
                if (response.body.results && response.body.results.length > 0) {
                    
                    // console.log("response.body.results", response.body.results)

                    resolve(response.body.results.map((i: any)=>{

                        var label = `${i["firstName"]} ${i["lastName"]}`
                        if (i["employeeID"]) {
                            label = `${i["firstName"]} ${i["lastName"]} (${i["employeeID"]})`
                        }
                        return {label: label, value: i["id"], userType: i["userType"]}
                    }))
                    
                } else {
                    resolve([])
                }
            }).catch((err)=>{
                const apiErr = new APIError()
                apiErr.type = "http"
                apiErr.message = "Error fetching data"
                apiErr.details = (err.response || {text: err.toString()}).text
                reject(apiErr)
            })
        });
    }

    getProxyableFeatures = () => {
        request.get(`/api/portal-user-proxy/${this.state.portalUser.id}`).then((response: request.Response)=>{
        // request.get(`/api/portal-user-proxy/${this.state.portalUser.id.value}/features`).then((response: request.Response)=>{
            // console.log("response", response)
            if (!response.ok) {
                const apiErr = new APIError()
                apiErr.type = "api"
                apiErr.message = "Error fetching data"
                apiErr.details = response.body.toString()
                this.setState({
                    error: apiErr
                })
            } else {
                if (response.body) {

                    var proxyAssignments = Array<any>();
                    if (response.body.proxies) {
                        response.body.proxies.forEach((p: any)=>{
                            proxyAssignments.push(p)
                        })
                    }
    
                    // these features are scoped to the portal user which is having proxy administered to. 
                    var proxyAbleFeatures = Array<any>();

                    if (response.body.features) {
                        response.body.features.forEach((f: any)=>{
                            proxyAbleFeatures.push(f)
                        })
                    }
    
                    proxyAssignments.forEach((proxy: any)=>{
                        var features = Array<any>();
                        var rawFeatures = proxy.extendedAttributes["features"]
                        if (rawFeatures) {
                            rawFeatures.forEach((f: any)=>{
                                features.push(f)
                            })
                        }
                        proxy.extendedAttributes["features"] = features
                    })
    
                    this.setState({
                        status: "ready",
                        proxies: proxyAssignments,
                        features: proxyAbleFeatures
                    })
        
                }
            }
        }).catch((err)=>{
            const apiErr = new APIError()
            apiErr.type = "http"
            apiErr.message = "Error fetching data"
            apiErr.details = (err.response || {text: err.toString()}).text
            this.setState({
                error: apiErr
            })
        })
    }

    onPortalUserSelect = (attr: any, e:any) => (event: any, data: any) => {
        // console.log("onPortalUserSelect", data)
        if (data && data.suggestionValue && Object.keys(data.suggestionValue || {}).length > 0) {
                        
            if (data.suggestionValue.value) {
                
                this.setState({
                    portalUser: {
                        id: data.suggestionValue.value,
                        extendedAttributes: {
                            portalUserFullName: data.suggestionValue.label
                        },
                        userType: data.suggestionValue.userType
                    },
                    proxies: []
                }, ()=>{
                    this.getProxyableFeatures()
                })

            } else  {
                // console.log("nulling out portal user")
                this.setState({
                    portalUser: {},
                    features: [],
                    proxies: []
                })

            }
        } else {
            if (data.suggestionValue) {
                this.setState({})
            }
        }
    }

    onProxyChange = (proxy: any) => {
        this.setState({})
    }

	render() {
		const { error, status, success, portalUser, features } = this.state;
        const { classes }: { classes: ClassNameMap } = this.props;

        var {proxies} = this.state
        
        // var {portalUserID} = this.props

		var errorView ;
		if (error) {
			errorView = <ErrorView classes={{}} error={error} onClose={this.onErrorClose} />;
		}

		var successView ;
		if (success) {
			successView = <SuccessView classes={{}} message={success} onClose={this.onSuccessClose} />;
        }
        
        // console.log("edit proxy state", this.state)
        
        proxies = proxies.filter((p: any)=>{return !p.extendedAttributes["_delete"]})
        
		
		let view ;
		if (status === 'loading') {
			view = <LoadingView classes={{}} />;
		} else if (true) {
			view = (
				<div className={classes.container}>
					<Paper className={classes.headerPaper}>
						<Typography className={classes.headerTitle} variant="h6">
							Proxy Admin
						</Typography>
                        <Grid style={{marginTop: 10}} container spacing={8}>
                            {<Grid item style={{paddingTop: 5}} xl={3} lg={3} md={3} sm={3} xs={3}><FormControl className={classes.searchField}>
                                <InputLabel error={false}  shrink className={classes.searchFieldLabel} required={true}>{"Portal User"}</InputLabel>
                                <AutoSuggest
                                    displayClearAdornment={true}
                                    emitClear={true}
                                    maxHeight={200}
                                    name="portalUser"
                                    minQueryChars={3}
                                    preventBusyTab={true}
                                    autoSelectOptions={false}
                                    classes={{}}
                                    placeholder=""
                                    value={portalUser.extendedAttributes && portalUser.extendedAttributes["portalUserFullName"] ? portalUser.extendedAttributes["portalUserFullName"] : ""}
                                    fetchSuggestions={this.fetchSuggestions("/portal-user-proxy/search-users?status=Active&userType=Internal&term=", "proxyUser")}
                                    onSuggestionSelected={this.onPortalUserSelect(portalUser.extendedAttributes, this)}
                                    disabled={false}
                                >
                                </AutoSuggest>
                                <FormHelperText style={{color: 'red'}}>{portalUser.id && features.length == 0 ? 'This user does not have any features available for proxy' : ''}</FormHelperText>
                            </FormControl></Grid>}
                            
                    	</Grid>
                        
                        <Typography style={{marginTop: 20, marginBottom: 10}} className={classes.headerTitle} variant="h6">
							Proxies
						</Typography>

                        {proxies.map((p: any, idx)=>{
                            return (
                                <ProxyFeatureAssignment userType={portalUser.userType || "Internal"} idx={idx} key={idx} proxy={p} proxies={proxies} features={features} onProxyChange={this.onProxyChange}></ProxyFeatureAssignment>
                            )
                        })}
                           

                            <Grid item  xl={12} lg={12} md={12} sm={12} xs={12}>
                                {proxies.length == 0 && <EmptySet classes={{}} text="No proxies have been provided" />}
                                {/* {(portalUser.id.value && features.length == 0) && <EmptySet classes={{}} text="This user does not have any features available for proxy" />} */}
                            </Grid>
                                
                            <Grid item  style={{marginTop: 10}} xl={2} lg={2} md={2} sm={2} xs={2}>
                                <Tooltip disableFocusListener={(portalUser.id && features.length > 0) ? true : false} disableTouchListener={(portalUser.id && features.length > 0) ? true : false} disableHoverListener={(portalUser.id && features.length > 0) ? true : false} title={(portalUser.id && features.length == 0) ? "This user does not have any features available for proxy" : "Select a Portal User First"}>
                                    <div className={classes.adhoc}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={this.newProxy}
                                            disabled={ (!portalUser.id || (portalUser.id && features.length == 0)) ? true : false}
                                        >
                                            Add New
                                        </Button>
                                    </div>
                                </Tooltip>
                            </Grid>
                     
				    </Paper>
	
				<Toolbar disableGutters classes={{ root: classes.admintoolbar }}>
					<Button
						variant="contained"
						color="inherit"
						disabled={this.state.status == 'saving'}
						onClick={this.cancel}
					>
						Cancel
					</Button>
					<Button
						style={{marginLeft: 10}}
						variant="contained"
						color="primary"
						disabled={this.state.status == 'saving'}
						onClick={this.handleSaveClick}
					>
						Save
					</Button>
				</Toolbar>
			</div>
		);
	}

		return (
			<div className={classes.container}>
				{errorView}
				{successView}
				{view}
			</div>
		);
	}
}

export default withStyles(styles)(PcardFeatureProxyEditView);



